import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import './Report.scss';
import jsonData from './Json';
import { Helmet } from 'react-helmet';

const Report = () => {
  const handleNavigate = (Item) => {
    const dynamicUrl = `/internship-report/${Item}`;
    const fullUrl = window.location.origin + dynamicUrl;
    window.open(fullUrl, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Internship Final Year Report | V-Ex Tech Solution</title>
        <meta
          name="description"
          content="Download internship final year reports for Data Science, MERN Stack, Python, Software Testing, and more. Prepared by V-Ex Tech Solution, Vadodara."
        />
      </Helmet>

      <div className="report-main">
        <h1 className="report-title">Internship Project Reports</h1>
        <p className="report-subtitle">
  Select your internship domain to view available project reports.
</p>


        <Tabs>
          <TabList>
            {jsonData.map((item) => (
              <Tab key={item.title}>{item.title}</Tab>
            ))}
          </TabList>

          {jsonData.map((item) => (
            <TabPanel key={item.title}>
              <div className="content-on">
                {item.cards.map((card) => (
                  <div
                    className="report-card"
                    key={card.value}
                    onClick={() => handleNavigate(card.value)}
                  >
                    <div className="card-overlay">
                      <h2>{card.value}</h2>
                      <p>{card.project}</p>
                      <span className="click-text">Click to View</span>
                    </div>
                  </div>
                ))}
              </div>
            </TabPanel>
          ))}
        </Tabs>
      </div>
    </>
  );
};

export default Report;
